import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FoodCard from "./food-card";

const foodVendors = [
  {
    name: "Bundobust",
    sort: "bundobust",
    link: "https://bundobust.com/locations/bundobust-brewery/",
    img: "bundo.png",
    location: "Oxford Rd, Piccadilly Approach & Projekts Skate Park",
  },
  {
    name: "FEDERAL",
    sort: "federal",
    link: "https://www.federalcafe.co.uk/oxford-road/",
    img: "federal.png",
    location: "Circle Square (Oxford Road)",
  },
  {
    name: "Gorilla Kitchen",
    sort: "gorilla",
    link: "https://www.thisisgorilla.com/bar-restaurant/",
    img: "gorilla.jpg",
    location: "Gorilla",
  },
  {
    name: "HELLO ORIENTAL",
    sort: "hello oriental",
    link: "https://hofoodhall.com/",
    img: "hellooriental.png",
    location: "Circle Square (Cactus Square)",
  },
  {
    name: "Pan Asian Street Food",
    sort: "Pan Asian Street Food",
    link: "https://info.northbrewing.com/venue/north-taproom-circle-square/",
    img: "north.png",
    location: "North Bar (Cactus Square) & Projekts Skate Park",
  },
  {
    name: "PEPPERONI PLAYBOY",
    sort: "pepperoni playboy",
    link: "https://www.yes-manchester.com/pdf/menus_3.pdf",
    img: "pep.png",
    location: "YES",
  },
  {
    name: "Pieminster",
    sort: "Pieminster",
    link: "https://www.instagram.com/theabbeymanchester/",
    img: "piemin.jpg",
    location: "Circle Square & The Abbey",
  },
  {
    name: "Poutine Punks",
    sort: "poutine punks",
    link: "https://www.instagram.com/poutinepunks/",
    img: "poutinepunks.png",
    location: "Circle Square (Cactus Square)",
  },
  {
    name: "RIZZO’S SICILIAN FOOD",
    sort: "rizzos",
    link: "https://www.instagram.com/rizzos_sicilian_food/",
    img: "scicillian.png",
    location: "Circle Square (Cactus Square)",
  },
  {
    name: "SEITANS KEBABS",
    sort: "seitans",
    link: "https://seitanskebab.co.uk/",
    img: "seitans.jpg",
    location: "Circle Square (Cactus Square)",
  },
  {
    name: "Trippy Chippy",
    sort: "trippy chippy",
    link: "https://www.yes-manchester.com/pdf/menus_5.pdf",
    img: "trippychip.jpg",
    location: "Yes",
  },
];

const sortedFoodVendors = foodVendors.sort((a, b) =>
  a.sort.localeCompare(b.sort),
);

function Art() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}>
        {sortedFoodVendors.map((food) => (
          <FoodCard key={food.name} artist={food} />
        ))}
      </Box>
    </Container>
  );
}
export default Art;
